import { Routes } from '@angular/router';

export const routesSysadminPrecificacao: Routes = [
  {
    path: 'custos_por_dominio',
    data: {
      preload: false,
      module: 'CUSTOS_DOMINIO',
      breadcrumb: {
        label: 'Tabela de custos por domínio',
        icon: 'pi pi-fw pi-chart-bar'
      },
      backend_path: '/domains/get_usage_info_by_domain'
    },
    loadChildren: () =>
      import('@app/modules/table_cost_domain/costs_domain.module').then(
        m => m.CostDomainModule
      )
  },
  {
    path: 'pesos_aplicacao',
    data: {
      module: 'PESOS_APLICACAO',
      preload: false,
      breadcrumb: {
        label: 'Pesos por aplicação',
        icon: 'mdi mdi-numeric'
      },
      backend_path: '/constant_for_calculations'
    },
    loadChildren: () =>
      import(
        '@app/modules/constants_for_calculation/constants_for_calculation.module'
      ).then(m => m.ConstantsModule)
  },
  {
    path: 'custos_aplicacao',
    data: {
      module: 'CUSTOS_APLICACAO',
      preload: false,
      breadcrumb: {
        label: 'Custos por aplicação',
        icon: 'mdi mdi-cash'
      },
      backend_path: '/project_costs'
    },
    loadChildren: () =>
      import('@app/modules/project_cost/project_cost.module').then(
        m => m.ProjectCostModule
      )
  }
];
